import { Select as ChakraSelect } from "@chakra-ui/react";

const Select = (props) => <ChakraSelect {...props} />;

export default Select;
